import {
  addColumns,
  downloadExcel,
} from "@/Utils/importCommon/downloadFunctions";
import { translate } from "@/translations/functions/hook";

import { Workbook } from "exceljs";

import { getEventsColumns } from "./columnFunctions";

const addEventsSheet = (workbook: Workbook) => {
  const sheet = workbook.addWorksheet(
    translate("importLabels:eventsSheetTitle"),
  );

  const eventsColumns = getEventsColumns({}).filter((col) => !col.hideColumn);
  addColumns(sheet, eventsColumns);

  sheet.getCell(2, 1).value = new Date().toISOString();
};

export const downloadForEvents = async (title: string) => {
  const workbook = new Workbook();

  addEventsSheet(workbook);

  downloadExcel(title, workbook);
};
